import { Layers } from 'lucide-react';
import { useTheme } from '@app/theme/ThemeContext';

interface MapControlButtonsProps {
  onLayersClick: () => void;
}

export default function MapControlButtons({ onLayersClick }: MapControlButtonsProps) {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={onLayersClick}
      className={`w-10 h-10 rounded-xl shadow-sm border flex items-center justify-center transition-colors ${
        isDark
          ? 'bg-gray-800 hover:bg-gray-700 border-gray-700 text-gray-100'
          : 'bg-white hover:bg-gray-50 border-gray-200 text-gray-900'
      }`}
      title="Edit Layers"
    >
      <Layers className="w-4 h-4" />
    </button>
  );
}
